import React from 'react';
import { useProjectScenarios } from '../../../context/ProjectScenariosContext';
import { useTranslation } from 'react-i18next';

interface ScenarioSwitcherProps {
  scenarioId: string | undefined;
  setScenarioId: (id: string) => void;
  onSave?: () => void;
  saving?: boolean;
}

const ScenarioSwitcher: React.FC<ScenarioSwitcherProps> = ({ scenarioId, setScenarioId, onSave, saving }) => {
  const { t } = useTranslation(['common', 'screens']);
  const { scenarios } = useProjectScenarios();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
      <label style={{ fontWeight: 500, marginRight: 8 }}>{t('screens:projects.scenario')}</label>
      <select
        className="form-select"
        style={{ width: 220, display: 'inline-block' }}
        value={scenarioId || ''}
        onChange={e => setScenarioId(e.target.value)}
      >
        {scenarios.map(s => (
          <option key={s.id} value={s.id}>{s.name}</option>
        ))}
      </select>
      <button
        className="btn btn-primary"
        onClick={onSave}
        disabled={saving}
        style={{ marginLeft: 8 }}
      >
        {saving ? t('screens:projects.saving') : t('screens:projects.saveScenario')}
      </button>
    </div>
  );
};

export default ScenarioSwitcher;
